import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200",
  class: "icon",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#d81e06",
      d: "M997.647 819.149v-.138L577.848 91.899h-.071c-5.253-19.354-29.25-33.874-58.071-33.874-29.03 0-52.946 14.868-57.995 34.432L32.026 836.608l.353.492c-9.82 9.748-7.926 32.89 5.396 54.492 13.4 22.026 33.593 34.299 46.638 29.245l.492.768H954.66l.491-1.116c14.52 2.243 32.4-10.527 43.551-33.25 13.04-26.152 12.201-55.608-1.055-68.09M458.84 320.522c0-32.19 26.158-58.276 58.276-58.276 32.261 0 58.28 26.087 58.28 58.276v300.37c0 32.113-26.019 58.276-58.28 58.276-32.118 0-58.276-26.158-58.276-58.276zm58.281 524.293c-34.995 0-63.396-28.405-63.396-63.467 0-35 28.4-63.263 63.396-63.263 34.995 0 63.39 28.268 63.39 63.263 0 34.99-28.395 63.467-63.39 63.467"
    }, null, -1)
  ])))
}
export default { render: render }